import { z } from "zod";

const asciiEmail = z.string().transform((value) => value.trim()).pipe(
  z.string().min(1, "請輸入電子郵件").max(254, "電子郵件不得超過 254 字元")
    .regex(/^[\x21-\x7e]+$/, "第一版電子郵件僅支援 ASCII，不支援 EAI 或 IDN")
    .email("請輸入有效的電子郵件"),
);

export const registerSchema = z.object({
  industry: z.string().min(1, "請選擇廠商類別"),
  registrantName: z.string().trim().min(1, "請輸入姓名").max(100),
  companyName: z.string().trim().min(1, "請輸入公司名稱").max(200),
  phone: z.string().regex(/^[0-9-]+$/, "電話只可包含數字與連字號").refine((value) => { const phone = value.replaceAll("-", ""); return (phone.length === 10 && phone.startsWith("09")) || ([9, 10].includes(phone.length) && phone.startsWith("0")); }, "請輸入台灣手機或含區碼市話"),
  email: asciiEmail,
  username: z.string().regex(/^[A-Za-z0-9]{6,30}$/, "帳號須為 6–30 個英文字母或數字"),
  password: z.string().min(6, "密碼至少需要 6 個字元"),
  confirmPassword: z.string().min(6, "請再次輸入密碼"),
  referralChannel: z.string().min(1, "請選擇得知管道"),
  taxId: z.string().refine((value) => value === "" || /^[0-9]{8}$/.test(value), "統一編號須為 8 碼數字"),
  companyCity: z.string(),
  establishmentDate: z.string().refine((value) => value === "" || value <= new Date().toISOString().slice(0, 10), "成立時間不得晚於今天"),
  employeeBand: z.string().min(1, "請選擇員工人數規模"),
  revenueBand: z.string().min(1, "請選擇年營收規模"),
  marginBand: z.string().min(1, "請選擇毛利率區間"),
  privacyConsent: z.boolean().refine((value) => value, "請確認個資告知與具名資料永久保存政策"),
}).superRefine((value, context) => {
  if (value.password !== value.confirmPassword) context.addIssue({ code: "custom", path: ["confirmPassword"], message: "密碼不一致" });
});

export const loginSchema = z.object({ identifier: z.string().trim().min(1, "請輸入帳號或電子郵件"), password: z.string().min(1, "請輸入密碼") });
export const forgotPasswordSchema = z.object({ email: asciiEmail });
export const resetPasswordSchema = z.object({ password: z.string().min(6, "密碼至少需要 6 個字元"), confirmPassword: z.string().min(6) }).refine((value) => value.password === value.confirmPassword, { path: ["confirmPassword"], message: "密碼不一致" });

export type RegisterValues = z.infer<typeof registerSchema>;
export type LoginValues = z.infer<typeof loginSchema>;
